
<div class="responder-page">
    <div class="header">
        <div class="video-information">
            <span class="logo">
                <img src="../../assets/images/logo.png" />
            </span>
            <h4 class="title">{{invitationObj['channel']}}</h4>
            <!-- <h4 id="errmsg"></h4> -->
            <!----Channel Name: -->
            <p class="mobile-number">Mobile No: {{invitationObj['uid']}}</p>

            <span class="share-location">
                <!-- <img src="../../assets/images/share-location.png" /> -->
                <i class="fa fa-map-marker" aria-hidden="true"></i>
            </span>
        </div>
    </div>

    <div class="container-fluid">
        <h3 class="video-call-title">{{clientName}}</h3>
        <div class="form-group" hidden style="display: none !important;">
            <select class="form-select" id="video-source" [(ngModel)]="selStreamId"
                (change)="changeStream($event)"></select>
            <!-- <button id="toggleVideoBtn" class="btn btn-sm-default cameraBtn" (click)="switchCamera()" >{{isFrontCameraEnabled?'Back Camera':'Front Camera'}}</button> -->
        </div>
        <div class="video-player-remote-user caller-video" id="me"></div>
        <div class="video-player reciver-video" id="remote-container"></div>
        <!-- <div class="video-player-remote-user" id="me" style=""></div>
        <div class="video-player-remote-user" id="remote-container" #remoteVideo></div> -->

        <div class="row video-action-btn" *ngIf="recordingStarted">
            <div class="col-md-12 text-center">
                <ul class="player-buttons">
                    <!-- <li>
                        <button type="button" class="btn btn-shadow capture">
                            <i class="fa fa-picture-o" aria-hidden="true"></i>
                        </button>
                    </li> -->
                    <!-- <li>
                        <button type="button" class="btn btn-shadow sound-btn">
                            <i class="fa fa-microphone" aria-hidden="true" style="display:none;"></i>
                            <i class="fa fa-microphone-slash" aria-hidden="true" ></i>
                        </button>
                    </li> -->
                    <li>
                        <button *ngIf="!isMute" type="button" class="btn btn-shadow capture mx-1" style="color: #327103;"
                            (click)="muteTheCallAudio()">
                            <i  class="fa fa-volume-up" aria-hidden="true"></i>
                        </button>
                        <button *ngIf="isMute" type="button" class="btn btn-shadow capture mx-1" style="color: #327103;"
                            (click)="unmuteTheCallAudio()">
                            <i class="fa fa-volume-off"  aria-hidden="true"></i>
                        </button>
                    </li>
                    <li>
                        <!-- <button type="button" (click)="switchDevice()" -->
                        <button type="button" (click)="switchCamera()"
                        class="btn btn-shadow active mx-1">
                            <!-- <i class="fa fa-camera" aria-hidden="true"></i> -->
                            <svg width="24px" height="24px" style="position:relative;top:-2px" viewBox="0 0 48.00 48.00" version="1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 48 48" fill="#3d3d3d" stroke="#3d3d3d" transform="matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.576"></g><g id="SVGRepo_iconCarrier"> <g fill="#171717"> <path d="M33.9,12.1H14.2L17.6,7c0.4-0.6,1-0.9,1.7-0.9h9.6c0.7,0,1.3,0.3,1.7,0.9L33.9,12.1z"></path> <path d="M14,11H8V9.2C8,8.5,8.5,8,9.2,8h3.6C13.5,8,14,8.5,14,9.2V11z"></path> <path d="M40,42H8c-2.2,0-4-1.8-4-4V14c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v24C44,40.2,42.2,42,40,42z"></path> </g> <path fill="#E8EAF6" d="M34,25c0-5.5-4.5-10-10-10c-2.4,0-4.6,0.8-6.3,2.2l1.2,1.6c1.4-1.1,3.1-1.8,5.1-1.8c4.4,0,8,3.6,8,8h-3.5 l4.5,5.6l4.5-5.6H34z"></path> <path fill="#E8EAF6" d="M29.1,31.2C27.7,32.3,25.9,33,24,33c-4.4,0-8-3.6-8-8h3.5L15,19.4L10.5,25H14c0,5.5,4.5,10,10,10 c2.4,0,4.6-0.8,6.3-2.2L29.1,31.2z"></path> </g></svg>
                        </button>
                    </li>
                    <li>
                        <button type="button" (click)="showConfirmationModal = true"
                            class="btn btn-shadow play-stop active mx-1">
                            <i class="fa fa-phone" aria-hidden="true"
                                style="transform-origin: center;transform: rotate(137deg);"></i>
                        </button>
                    </li>
                    <!-- <li>
                    <button type="button" class="btn btn-shadow on-recording">
                        <i class="fa fa-dot-circle-o" aria-hidden="true"></i>
                    </button>
                    </li> -->

                </ul>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-sm btn-shadow btn-primary mx-1"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</button>
                <button type="button" class="btn btn-sm btn-shadow btn-secondary mx-1"><i class="fa fa-times-circle-o" aria-hidden="true"></i> Cancle</button>
            </div>
        </div>     -->
        <!-- <div class="row" style="top: 50px; position: relative;">
            
            <div class="col-12">
                <select name="deviceId" id="deviceId" [(ngModel)]="deviceId" (ngModelChange)="switchDeviceWithId($event)">
                    <option *ngFor="let camera of DevicesLog?.cameras" [value]="camera?.deviceId" >{{camera?.label}}</option>
                </select>
                
            </div>
            {{deviceId}}
        </div> -->
    </div>

    <!--error message modal-->
    <!-- Modal -->
    <div class="modal error-message-modal" id="errormsgModal" style="display: none;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle"></h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage"></p>
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
                    <button type="button" (click)="closeErrorModal()" class="btn btn-primary btn-sm"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Ok</button>
                </div>
            </div>
        </div>
    </div>

    <!--message modal-->
    <!-- Modal -->
    <div class="modal error-message-modal" id="confirmationModal"
        [ngStyle]="{'display': showConfirmationModal?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle">Close Video Call</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage">Are you sure?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" (click)="showConfirmationModal=false"
                        data-dismiss="modal"><i class="fa fa-times-circle-o" aria-hidden="true"></i> No</button>
                    <button type="button" (click)="closeMeeting()" class="btn btn-primary btn-sm"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Yes</button>
                </div>
            </div>
        </div>
    </div>

    <!-- Success message popup -->
    <div class="modal error-message-modal" id="confirmationModal"
        [ngStyle]="{'display': showConfirmationModal?'block':'none'}">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="errormodaltitle">Close Video Call</h5>
                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button> -->
                </div>
                <div class="modal-body" id="errormodalbody">
                    <p id="errormodalmessage">Are you sure?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary btn-sm" (click)="showConfirmationModal=false"
                        data-dismiss="modal"><i class="fa fa-times-circle-o" aria-hidden="true"></i> No</button>
                    <button type="button" (click)="closeMeeting()" class="btn btn-primary btn-sm"><i class="fa fa-check-circle-o" aria-hidden="true"></i> Yes</button>
                </div>
            </div>
        </div>
    </div>
</div>